import { sendGet, sendPost, sendDelete, sendPostForExport } from 'helpers/axios';

export const apiGetListJD = (params) => sendGet(`/api/jd/get-list`, params);
export const apiCreateOrUpdateJD = (params) => sendPost(`/api/jd/save`, params);
export const apiDeleteJD = (params) => sendDelete(`/api/jd/delete`, params);
export const apiExportJD = (jd_id) => sendPostForExport(`/api/jd/export/${jd_id}`);
